import { defineStore } from 'pinia'

export const useFetchPendingRequestsStore = defineStore('fetchPendingRequests', {
    state: () => ({
        abortControllers: []
    }),

    actions: {
        addAbortController (controller) {
            this.abortControllers.push(controller)
        },

        abortPendingRequests () {
            /**
             * Cancel all request where a token exists
             */
            this.abortControllers.forEach((controller) => {
                if (controller.abort) {
                    controller.abort('__abc_http_cancel')
                }
            })

            /**
             *  Reset the cancelTokens store
             */
            this.clearPendingControllers()
        },

        clearPendingControllers () {
            this.abortControllers = []
        }
    }
})
